import { useDispatch, useSelector } from 'react-redux';
import { HospitalNetworkSearchParams } from '@apis/HospitalNetworkApi';
import { hospitalsFetch } from './action';
import { selectHospitalNetworkPage } from './selector';

export const useHospitalNetworkPage = () => {
  const dispatch = useDispatch();
  const { hospitals, isLoading, error, pagination, searchParams } = useSelector(selectHospitalNetworkPage);

  const fetchHospitals = (params?: HospitalNetworkSearchParams) => {
    dispatch(hospitalsFetch(params));
  };

  return {
    hospitals,
    isLoading,
    error,
    pagination,
    searchParams,
    fetchHospitals,
  };
};
